<template>
    <!-- 筛选栏 -->
    <el-card class="filter-card" shadow="never">
        <el-form :inline="true" :model="filters" class="filter-form">
            <el-form-item label="名称">
                <el-input v-model="filters.name" placeholder="名称" clearable />
            </el-form-item>
            <el-form-item label="分类">
                <el-select v-model="filters.categoryId" class="level-select" placeholder="分类" clearable
                    style="width: 120px">
                    <el-option v-for="item in cardCategoryStore.categories" :key="item.id" :label="item.name"
                        :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="标签">
                <el-select v-model="filters.tagId" class="level-select" placeholder="标签" clearable style="width: 120px">
                    <el-option v-for="item in cardTagStore.tags" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </el-form-item>
            <el-form-item label="稀有度">
                <el-select v-model="filters.rarity" class="level-select" placeholder="稀有度" clearable
                    style="width: 60px">
                    <el-option v-for="r in ALL_RARITY" :key="r" :label="r" :value="r" />
                </el-select>
            </el-form-item>
            <el-form-item label="类型">
                <el-select v-model="filters.type" class="level-select" placeholder="类型" clearable style="width: 160px">
                    <el-option v-for="key in Object.keys(CARD_TYPE)" :key="key" :label="CARD_TYPE[key]" :value="key" />
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="loadData">搜索</el-button>
                <el-button @click="resetFilters">重置</el-button>
                <el-divider direction="vertical" />
                <el-button type="primary" @click="addCard">新增</el-button>
            </el-form-item>
        </el-form>
    </el-card>
    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">

        <div class="table-wrapper">
            <el-table :data="rows" v-loading="loading" @sort-change="handleSortChange" style="width: 100%">
                <el-table-column fixed prop="id" label="ID" width="200" sortable="custom">
                    <template #default="scope">
                        <el-link underline="always" type="primary" @click="viewCard(scope.row.id)">{{ scope.row.id
                        }}</el-link>
                        <CopyButton :text="scope.row.id" />
                    </template>
                </el-table-column>

                <el-table-column fixed prop="image" label="Image" width="100">
                    <template #default="scope">
                        <img v-if="!!scope.row.image" class="table-image" :src="scope.row.image" alt="image"
                            loading="lazy" @click="openPreview(scope.row.index)" />
                    </template>
                </el-table-column>
                <el-table-column label="类型" prop="type" width="150">
                    <template #default="scope">
                        <el-text class="mx-1">{{ CARD_TYPE[scope.row.type] || scope.row.type }}</el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="Name" width="160">
                    <template #default="scope">
                        {{ scope.row.name }}
                        <CopyButton :text="scope.row.name" />
                    </template>
                </el-table-column>
                <el-table-column prop="categoryNameStr" label="分类/碎片" width="160" />
                <el-table-column prop="tagNameStr" label="标签" width="160" />
                <el-table-column prop="rarity" label="稀有度" width="80" />
                <el-table-column prop="value" label="价值" width="80" sortable="custom" />
                <el-table-column prop="allowExchange" label="兑换积分" width="80">
                    <template #default="scope">
                        <el-icon><Select v-if="scope.row.allowExchange" /></el-icon>
                    </template>
                </el-table-column>
                <el-table-column prop="allowShip" label="邮寄提现" width="80">
                    <template #default="scope">
                        <el-icon><Select v-if="scope.row.allowShip" /></el-icon>
                    </template>
                </el-table-column>

                <el-table-column fixed="right" label="操作" min-width="120">
                    <template #default="scope">
                        <el-link underline="always" type="primary" @click="viewCard(scope.row.id)">详情</el-link>
                        <el-divider direction="vertical" />
                        <el-link underline="always" type="primary" @click="editCard(scope.row.id)">编辑</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-image-viewer v-if="showPreview" :url-list="rows.map(row => row.image)" :initial-index="previewIndex"
                @close="showPreview = false" :hide-on-click-modal="true" />
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
            <el-pagination v-model:current-page="filters.page" v-model:page-size="filters.size"
                :page-sizes="[10, 20, 50]" :total="filters.total" layout="total, sizes, prev, pager, next, jumper"
                @current-change="loadData" @size-change="loadData" />
        </div>
    </el-card>
</template>

<script setup>
import { ref, reactive, watch, onMounted } from "vue";
import { useRoute, useRouter } from 'vue-router';
import { apiCall } from "@/utils/api";
import { ALL_RARITY, CARD_TYPE } from "@/utils/constant";
import { useCardCategoryStore } from "@/stores/card/category";
import { useCardTagStore } from "@/stores/card/tag";
import { useCardFragmentStore } from "@/stores/card/fragment";

const cardCategoryStore = useCardCategoryStore();
const cardTagStore = useCardTagStore();
const cardFragmentStore = useCardFragmentStore();

const route = useRoute();
const router = useRouter();

const loading = ref(false);
const rows = ref([]);

const filters = reactive({
    name: route.query.name || "",
    categoryId: route.query.categoryId || "",
    tagId: route.query.tagId || "",
    rarity: route.query.rarity || "",
    type: route.query.type || "",

    page: Number(route.query.page) || 1,
    size: Number(route.query.size) || 20,
    total: 0,

    sort: route.query.sort || "",
});

async function handleSortChange({ prop, order }) {
    filters.sort = `${prop},${order}`;
    await loadData();
}

watch(
    filters,
    (val) => {
        router.replace({ query: { ...val } });
    },
    { deep: true }
);

async function resetFilters() {
    filters.name = "";
    filters.categoryId = "";
    filters.tagId = "";
    filters.rarity = "";
    filters.type = "";
    filters.page = 1;
    await loadData();
}

const showPreview = ref(false);
const previewIndex = ref(0);

const openPreview = (index) => {
    previewIndex.value = index
    showPreview.value = true
}

function addCard(id) {
    router.push(`/card/add`);
}

function viewCard(id) {
    router.push(`/card/${id}`);
}

function editCard(id) {
    router.push(`/card/edit/${id}`);
}

async function loadData() {
    loading.value = true;

    const params = {
        page: filters.page || 1,
        size: filters.size || 20,
    };
    if (filters.name) {
        params.name = filters.name;
    }
    if (filters.categoryId) {
        params.categoryId = filters.categoryId;
    }
    if (filters.tagId) {
        params.tagId = filters.tagId;
    }
    if (filters.rarity) {
        params.rarity = filters.rarity;
    }
    if (filters.type) {
        params.type = filters.type;
    }

    if (filters.sort) {
        params.sort = filters.sort;
    }

    const response = await apiCall("card.getCards", params);
    if (!response) {
        return false;
    }
    filters.total = response.count;
    rows.value = response.rows.map(row => {
        row.categoryNameStr = "";
        if (row.type === "card") {
            row.categoryNameStr = row.categoryIds.map(c => cardCategoryStore.categoryObj[c]).join(",");
        } else if (row.type === "fragment") {
            row.categoryNameStr = row.categoryIds.map(c => cardFragmentStore.fragmentObj[c]).join(",");
        }

        row.tagNameStr = row.tagIds.map(t => cardTagStore.tagObj[t]).join(",");
        return row;
    });

    loading.value = false;
}

onMounted(async () => {
    await cardCategoryStore.getAll();
    await cardTagStore.getAll();
    await cardFragmentStore.getAll();
    await loadData();
});
</script>

<style scoped>
.table-image {
    width: 60px;
    height: 90px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #e5e5e5;
}
</style>
